var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"page-title",domProps:{"textContent":_vm._s(_vm.$t('context.driversPage.pages.interactiveTool.pageNameLong'))}}),_c('p',{staticClass:"sub-title",domProps:{"textContent":_vm._s(_vm.$t('context.driversPage.pages.interactiveTool.subTitle'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }